import React, { useState } from "react";
import Modal from "../../../../../parts/modal-new";
import BodyPhotos from "./BodyPhotos";
import StatInformation from "./StatInformation";
import useWindowSize from "../../../../../hooks/useWindowSize";
import moment from "moment";
import Photo from "./Photo";
import SvgIcon from "../../../../../parts/SvgIcon";

const CompareListPhotosModal = ({
  selectedPhotos,
  setSelectedPhotos,
  closeModal,
  closeModalAndReset,
  sides,
  compareOnlyTwo,
}) => {
  const changePicture = (photo) => {
    setSelectedPhotos((prevSelectedPhotos) => {
      return prevSelectedPhotos.filter(
        (selectedPhoto) => selectedPhoto !== photo
      );
    });
    closeModal();
  };
  const windowSize = useWindowSize();

  const [zoomView, setZoomView] = useState(null);
  return (
    <Modal
      title="Compare Photos"
      className={"compare-list-ph"}
      onClose={closeModalAndReset}
      dontRefreshOnClose={true}
    >
      <div className="body">
        <header>
          {!zoomView ? (
            <>
              <hgroup>
                <div>
                  <p className="s1">
                    {moment(selectedPhotos[0].utcDate, "YYYYMMDD").format("LL")}
                  </p>
                  <StatInformation
                    stat={selectedPhotos[0]}
                    column={windowSize.innerWidth < 960 ? true : false}
                  />
                </div>
                <button
                  data-button-type="primary"
                  onClick={() => changePicture(selectedPhotos[0])}
                >
                  Change
                </button>
              </hgroup>
              <hgroup>
                <div>
                  <p className="s1">
                    {moment(selectedPhotos[1].utcDate, "YYYYMMDD").format("LL")}
                  </p>

                  <StatInformation
                    stat={selectedPhotos[1]}
                    column={windowSize.innerWidth < 960 ? true : false}
                  />
                </div>
                <button
                  data-button-type="primary"
                  onClick={() => changePicture(selectedPhotos[1])}
                >
                  Change
                </button>
              </hgroup>
            </>
          ) : (
            <>
              <div className="flex gap-2 items-center">
                <SvgIcon
                  src={"/img/new-icons/back-button.svg"}
                  onClick={() => setZoomView(null)}
                />
                {!compareOnlyTwo && (
                  <span>{capitalizeFirstLetter(zoomView)}</span>
                )}
              </div>
            </>
          )}
        </header>
        {!compareOnlyTwo && (
          <CompareAll
            sides={sides}
            selectedPhotos={selectedPhotos}
            zoomView={zoomView}
            setZoomView={setZoomView}
          />
        )}
        {compareOnlyTwo && (
          <CompareTwo
            sides={sides}
            selectedPhotos={selectedPhotos}
            zoomView={zoomView}
            setZoomView={setZoomView}
          />
        )}
      </div>
    </Modal>
  );
};
function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}
const CompareAll = ({ sides, selectedPhotos, zoomView, setZoomView }) => {
  if (zoomView)
    return (
      <section>
        <div className="flex gap-4">
          <Photo
            src={
              selectedPhotos[0].bodyPhotos[zoomView]
                ? selectedPhotos[0].bodyPhotos[zoomView].s3Path
                : null
            }
            className="progress-photo"
            key={selectedPhotos[0].bodyPhotos[zoomView]?.name || i}
          />

          <Photo
            src={
              selectedPhotos[1].bodyPhotos[zoomView]
                ? selectedPhotos[1].bodyPhotos[zoomView].s3Path
                : null
            }
            className="progress-photo"
            key={selectedPhotos[1].bodyPhotos[zoomView]?.name || i}
          />
        </div>
      </section>
    );
  return sides.map((type, i) => {
    return (
      <article>
        <Photo
          src={
            selectedPhotos[0].bodyPhotos[type]
              ? selectedPhotos[0].bodyPhotos[type].s3Path
              : null
          }
          className="progress-photo"
          key={selectedPhotos[0].bodyPhotos[type]?.name || i}
        />
        <button data-button-type="secondary" onClick={() => setZoomView(type)}>
          <SvgIcon src={"/img/new-icons/Zoom.svg"} />
          {capitalizeFirstLetter(type)}
        </button>

        <Photo
          src={
            selectedPhotos[1].bodyPhotos[type]
              ? selectedPhotos[1].bodyPhotos[type].s3Path
              : null
          }
          className="progress-photo"
          key={selectedPhotos[1].bodyPhotos[type]?.name || i}
        />
      </article>
    );
  });
};
const CompareTwo = ({ sides, selectedPhotos, zoomView, setZoomView }) => {
  return (
    <article>
      <Photo
        src={
          selectedPhotos[0].bodyPhotos[sides[0]]
            ? selectedPhotos[0].bodyPhotos[sides[0]].s3Path
            : null
        }
        className="progress-photo"
        key={selectedPhotos[0].bodyPhotos[sides[0]]?.name || i}
      />
      {!zoomView && (
        <button data-button-type="secondary" onClick={() => setZoomView(true)}>
          <SvgIcon src={"/img/new-icons/Zoom.svg"} />
        </button>
      )}
      <Photo
        src={
          selectedPhotos[1].bodyPhotos[sides[1]]
            ? selectedPhotos[1].bodyPhotos[sides[1]].s3Path
            : null
        }
        className="progress-photo"
        key={selectedPhotos[1].bodyPhotos[sides[1]]?.name || i}
      />
    </article>
  );
};
export default CompareListPhotosModal;
